import React from "react";
import cn from "classnames";
import styles from "./Experts.module.sass";
import Slider from "react-slick";
import Item from "./Item";
import Icon from "../../../components/Icon";

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Experts = () => {
  const expertsList = [
    {
      name: "Dorsa Jalaei",
      image: "/images/zova/dorsa.png",
      linkedin: "https://www.linkedin.com/in/dorsa-jalaei/",
    },
    {
      name: "Atra Ajdari",
      image: "/images/zova/atra.png",
      linkedin: "https://www.linkedin.com/in/atra-ajdari/",
    }
  ];

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    arrows: false,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 100000,
        settings: "unslick",
      },
    ],
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <h2 className={cn("h2", styles.title)}>Ready to start your longevity journey?</h2>
        </div>
        <div className={styles.wrap}>
          <Slider
            className={cn("team-slider", styles.slider)}
            {...settings}
            style={{ display: 'flex', justifyContent: 'center', gap: '0' }}
          >
            {expertsList.map((x, index) => (
              <div className={styles.slide} key={index}>
                <Item className={styles.item} item={x} />
              </div>
            ))}
          </Slider>
          <div className={cn(styles.text, "h4")}>
            To get started, book a 15-minute free meeting with our experts to see how Zova can help you in your longevity journey!
          </div>

          <a
            href="https://calendly.com/jalaeidorsa/zova-demo"
            className={cn("button", styles.button)}
          >
            Book Your Meeting
          </a>
        </div>
      </div>
    </div>
  );
};

export default Experts;